let apiUrl: string       = `https://__REACT_APP_ADMIN_SUBDOMAIN__.__REACT_APP_BASE_DOMAIN__/api`;
let baseUrl: string      = `https://__REACT_APP_FRONTEND_DOMAIN__/`;
let imageBaseUrl: string = `https://__REACT_APP_IMAGES_SUBDOMAIN__.__REACT_APP_BASE_DOMAIN__/`;

export const API_URL = apiUrl;
export const BASEURL = baseUrl;
export const IMAGE_BASEURL = imageBaseUrl;
export const CHART_API = `http://__REACT_APP_CHARTVIS_HOST__:5000/`;
export const INSTAGEAM_URL = 'https://www.instagram.com/empirio.ai';
export const FACEBOOK_URL = 'https://www.mitarbeiterbefragungen.net';//https://www.facebook.com/EmpirioDE/';
export const TIKTOK_URL = 'https://www.gothesis.de/themen';//'https://www.tiktok.com/@empirio.de';
export const UMFRAG_RATGEBER_URL = 'https://www.online-umfrage.org/';
export const FRONT_USER = '/frontuser';
export const MESSAGE_TIME = 15000;
export const LANGUAGE_CODE = 'DE';
export const LIMIT = '12';
export const OFFSET = '0';
export const RANKING_MAX_VALUE = 10;
export const META_TITLE_APPEND = ' | empirio';
export const META_TITLE_HOME_PREPEND = 'empirio - ';
export const META_TITLE_STATISTICS_PREPEND = '[Statistiken] ';
export const SITEKEY = '__REACT_APP_RECAPTCHA_SITE_KEY__';
export const UrlConstant = {
    header: ['umfrage-erstellen', 'surveyparticipation', 'meine-umfrage', 'survey', 'c3VydmV5', 'nsu', 'registrieren',],
    footer: ['umfrage-erstellen', 'surveyparticipation', 'meine-umfrage', 'survey', 'c3VydmV5', '/c3VydmV5', 's'],
}
export const MONTHLY_AMOUNT= localStorage.getItem('monthly_plan');
export const ANNUAL_AMOUNT= localStorage.getItem('quarterly_plan');
export const B2C_MONTHLY_AMOUNT= localStorage.getItem('sub_one_month_b2c_price_with_tax');
export const B2C_ANNUAL_AMOUNT= localStorage.getItem('sub_one_year_b2c_price_with_tax');
